import Vue from "vue"
import localForage from 'localforage'

Vue.localForage = Vue.prototype.$localForage = localForage
